import React, { useState, useEffect } from 'react';
import PageTitle from '../components/common/PageTitle';
import { subscriptionPlans } from '../data/subscriptionPlans';
import SubscriptionPlanCard from '../components/subscription/PlanCard';

const GiftPremiumPage: React.FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [recipientEmail, setRecipientEmail] = useState<string>('');
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false);
  
  useEffect(() => {
    document.title = 'Gift Legal Nest Premium';
  }, []);

  const handlePlanSelect = (planId: string) => {
    setSelectedPlan(planId);
    setShowEmailModal(true);
  };

  const handleGiftSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!recipientEmail || !recipientEmail.includes('@')) {
      // Show validation error
      return;
    }
    
    console.log(`Gifting ${selectedPlan} plan to ${recipientEmail}`);
    // Implement actual gift subscription logic here
    
    // Close modal and reset after submission
    alert(`Gift subscription to ${recipientEmail} is being processed!`);
    setShowEmailModal(false);
    setSelectedPlan(null);
    setRecipientEmail('');
  };

  const closeModal = () => {
    setShowEmailModal(false);
    setSelectedPlan(null);
    setRecipientEmail('');
  };

  return (
    <div className="container-custom py-10 px-4">
      <PageTitle title="Gift Legal Nest Premium" subtitle="Give the gift of premium legal insights and knowledge" />
      
      <div className="max-w-4xl mx-auto mb-10">
        <p className="text-center text-neutral-600 mb-8">
          Gift a Legal Nest Premium subscription to a colleague, friend, or family member interested in legal developments.
        </p>
      </div>
      
      {/* Plans grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
        {subscriptionPlans.map((plan) => (
          <SubscriptionPlanCard
            key={plan.id}
            plan={plan}
            onClick={handlePlanSelect}
            buttonText="Gift This Plan"
          />
        ))}
      </div>
      
      <div className="max-w-3xl mx-auto bg-neutral-50 p-6 rounded-lg border border-neutral-200">
        <h2 className="text-2xl font-serif font-bold mb-4 text-center">How Gifting Works</h2>
        <ol className="space-y-3 list-decimal pl-6">
          <li>Choose a subscription plan</li>
          <li>Enter the recipient's email address</li>
          <li>Complete the payment</li>
          <li>The recipient will receive an email with instructions to activate their gift subscription</li>
          <li>They can redeem the gift at their convenience</li>
        </ol>
        <p className="mt-4 text-sm text-neutral-600 text-center">
          NOTE: Gift subscriptions are non-refundable but can be transferred to a different email address if needed.
        </p>
      </div>
      
      {/* Email Modal */}
      {showEmailModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 animate-fade-in">
            <h3 className="text-xl font-bold mb-4">
              Enter Recipient's Email Address
            </h3>
            
            <form onSubmit={handleGiftSubmit}>
              <div className="mb-4">
                <label htmlFor="recipientEmail" className="block mb-2 text-neutral-700">
                  Email Address
                </label>
                <input
                  type="email"
                  id="recipientEmail"
                  value={recipientEmail}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                  className="w-full px-4 py-3 rounded-md border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  placeholder="friend@example.com"
                  required
                  autoFocus
                />
                <p className="text-sm text-neutral-500 mt-1">
                  We'll send gift redemption instructions to this email.
                </p>
              </div>
              
              <div className="flex gap-3 justify-end">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-5 py-2 rounded-md border border-neutral-300 hover:bg-neutral-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-5 py-2 bg-primary-500 text-white rounded-md hover:bg-primary-600"
                >
                  Continue to Payment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default GiftPremiumPage;